import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index.tsx';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionVideoGallery',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean',
      defaultValue: true
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'VideoGallery',
        options: {
          videos: [
            {
              src: 'https://scaleai.wistia.com/medias/ieikkjioxr',
              cover:
                'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fccd46a790de144e099a4f8a95746f349',
              paragraph: 'Upload documents, receive labeled structured data, and curate results.'
            },
            {
              src: 'https://scaleai.wistia.com/medias/u3mmx1zoku',
              cover:
                'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F657e7997af4c432c8b2ca0776f082b2e',
              paragraph: 'Flexport relies on Scale Document AI to process logistics documents.'
            },
            {
              src: 'https://scaleai.wistia.com/medias/5p34uli2b0',
              cover:
                'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F628de75fb11f47628a051264e85bc2d2',
              paragraph: 'Brex relies on Scale Document AI to process invoices.'
            }
          ]
        }
      }
    }
  ]
});
